import { render } from "./MNav.vue?vue&type=template&id=ed4971ca&scoped=true"
import script from "./MNav.vue?vue&type=script&lang=js"
export * from "./MNav.vue?vue&type=script&lang=js"

import "./MNav.vue?vue&type=style&index=0&id=ed4971ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed4971ca"]])

export default __exports__